import React from 'react'
import { v4 } from 'uuid'
import { ItemProd } from '../components/itemprod'

const futures = [
  {
    id: v4(),
    title: 'Без ФН',
    desc: '22.000,00',
  },
  {
    id: v4(),
    title: 'С фн на 15 месяцев',
    desc: '34.600,00',
  },
  {
    id: v4(),
    title: 'С фн на 36 месяцев',
    desc: '40.100,00',
  },
]

const data = {
  img: './images/st5line-02.png',
  title: 'Эвотор 5ST',
  desc: 'Компактная касса с возможностью модернизации до устройства 2 в 1, которое будет включать в себя кассу и терминал для приёма карт. Подойдёт тем, кому важна мобильность и автономность: интернет-магазинам, магазинам с курьерской доставкой и небольшим бизнесам.',
}

export const St5 = () => {
  return (
    <>
      <ItemProd data={data} futures={futures} />
    </>
  )
}
